'use strict';

module.exports = require('./utils/populate').default;


//////////////////
// WEBPACK FOOTER
// ./~/coact/populate.js
// module id = 1820
// module chunks = 0